import { createSelector } from 'reselect';

/* Refactor
	When direct access to data in store has been replaced with getter functions,
	those getter functions can replace allGames, keyFilter & providerFilter
 */
const allGames = (store) =>	store.gameResource;
const keyFilter = store => store.filters.key;
const providerFilter = store => store.filters.provider;

const gamesSelector = createSelector(
	[
		allGames,
		keyFilter,
	],
	(gameResource, filter) => {
		let games;
		if (filter) {
			games = gameResource.gameData.all.filter(
				game => {
					console.log(game[filter]);
					return game[filter];
				});
		} else {
			games = gameResource.gameData.all;
		}
		return games;
	}
);

const providerSelector = createSelector(
	allGames,
	providerFilter,
	(gameResource, filter) => {
		let games;
		if (filter) {
			games = gameResource.gameData.all.filter(game => game.provider.code === filter);
		} else {
			games = gameResource.gameData.all;
		}
		return games;
	}
);

export { gamesSelector, providerSelector };



// WEBPACK FOOTER //
// ./mobile-core/src/casino/selectors.js